import React from "react";
import { IoReload } from "react-icons/io5";

export const FetchError = () => {
  return (
    <div className="flex flex-col items-center shadow-lg p-6 mx-auto w-[90%] md:w-[45%] mt-10 rounded-xl bg-white text-center">
      <h2 className="text-2xl font-bold text-red-500 mb-2">Failed to Fetch Data</h2>
      <p className="text-gray-700 text-base mb-4">
        We rely on <span className="font-semibold text-gray-900">corsproxy.io</span> to connect to Swiggy's API.
        You may be experiencing rate limiting or temporary response restrictions from the proxy or server.
      </p>
      <p className="text-gray-500 text-sm mb-6">
        Please wait a few moments and try reloading the page.
      </p>
      <button
        className="flex items-center justify-center bg-orange-500 hover:bg-orange-600 text-white px-5 py-2.5 rounded-lg font-semibold shadow transition"
        onClick={() => window.location.reload()}
      >
        <IoReload className="mr-2 text-lg" /> Reload Page
      </button>
    </div>
  );
};

